import React from 'react';
import {
    ClientSideRowModelModule,
    CsvExportModule,
    ModuleRegistry,
    NumberFilterModule,
    TextFilterModule,
    DateFilterModule,
    CellStyleModule,
    ValidationModule,
    PaginationModule,
    ColumnAutoSizeModule,
    TooltipModule,
    themeQuartz,
    CustomFilterModule,
} from 'ag-grid-community';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import { DaylitTheme } from '@lendica/theme';

// Register only the modules needed from AG Grid to minimize bundle size
ModuleRegistry.registerModules([
    CustomFilterModule,
    ClientSideRowModelModule,
    CsvExportModule,
    NumberFilterModule,
    TextFilterModule,
    DateFilterModule,
    ValidationModule,
    CellStyleModule,
    PaginationModule,
    ColumnAutoSizeModule,
    TooltipModule,
]);

// to use myTheme in an application, pass it to the theme grid option
const myTheme = themeQuartz.withParams({
    accentColor: DaylitTheme.Palette.Burgundy,
    backgroundColor: '#FCFCFD',
    browserColorScheme: 'inherit',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Roboto',
        'Oxygen-Sans',
        'Ubuntu',
        'Cantarell',
        'Helvetica Neue',
        'sans-serif',
    ],
    foregroundColor: '#202024',
    headerFontSize: 14,
    wrapperBorder: false,
});

export const DataGrid = React.forwardRef<AgGridReact, AgGridReactProps>(
    ({ rowData, columnDefs, ...props }, ref) => {
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    minHeight: 240,
                }}
            >
                <AgGridReact
                    ref={ref}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    pagination={true}
                    theme={myTheme}
                    tooltipShowDelay={100}
                    enableFilterHandlers={true}
                    {...props}
                />
            </div>
        );
    }
);
